import {BitmapTextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/BitmapTextStyleOptions";
import {Power1, Timeline, TimelineLite, TweenLite} from "gsap";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {BonusBunniesBitmapWinCountUp} from "./BonusBunniesBitmapWinCountUp";

/**
 * Created by Jerker Nord on 2020-05-07.
 */

export class BonusBunniesBonusMultiplierWPCountUp extends BonusBunniesBitmapWinCountUp {

    private _countUpAnimationTL:TimelineLite;
    private _playSound:boolean;

    constructor(bitmapStyle:BitmapTextStyleOptions) {
        super(bitmapStyle);
    }

    public init():void {
        this.initAnimations();
    }

    public getCountUpAnimation(playSound:boolean, from:number, to:number, duration:number, multiplier:number):Timeline {
        this._playSound = playSound;
        if(this._countUpAnimationTL && this._countUpAnimationTL.isActive()) {
            this._countUpAnimationTL.pause();
            this._countUpAnimationTL.kill();
        }
        this._countUpAnimationTL = new TimelineLite();
        const oriNumber:number = MathHelper.floorToDecimals(to / multiplier, 2);
        this._countUpAnimationTL.add([
            () => {
                this._countUp.maxTextWidth = 140;
                this._countUp.visible = true;
                TweenLite.to(this._countUp, 0.3, {alpha : 1});
                this._countUpContainer.scale.set(1, 1);
            },
            this._countUp.getCountUpAnimation(this._playSound, from, oriNumber, {
                duration : duration,
                ease : Power1.easeIn
            })
        ]);

        return this._countUpAnimationTL;
    }

    public getEndingAnimation(endValue:number):Timeline {
        const timeline:TimelineLite = new TimelineLite();
        timeline.add(this._countUp.getCountUpAnimation(false, endValue, endValue, {duration : 0.01}));

        return timeline;
    }

    protected getAbortAnimation(endValue:number, multiplier:number):Timeline {
        if(this._countUpAnimationTL && this._countUpAnimationTL.isActive()) {
            this._countUpAnimationTL.pause();
            this._countUpAnimationTL.kill();
        }

        const timeline:TimelineLite = new TimelineLite();
        timeline.add([
            () => {
                this._countUp.maxTextWidth = 140;
                this._countUp.alpha = 1;
                this._countUp.visible = true;
                this._countUpContainer.scale.set(1, 1);
            },
            this._countUp.getCountUpAnimation(false, endValue, endValue, {duration : 0.01})
        ]);

        return timeline;
    }
}